(function () {
	'use strict';

	angular.module('l4b')
		.component('requiredDocumentationSubmitAutoSuccess', {
			templateUrl: 'html/shared/requiredDocumentationSubmitAutoSuccess/requiredDocumentationSubmitAutoSuccess.html',
			bindings: {
				nextStep: '&'
			},
			controller: RequiredDocumentationSubmitAutoSuccessController,
			controllerAs: 'vm'
		});

	RequiredDocumentationSubmitAutoSuccessController.$inject = ['RestService', 'Constants', 'StorageService', '$rootScope', 'GlobalizationService', '$window'];

	function RequiredDocumentationSubmitAutoSuccessController(RestService, Constants, StorageService, $rootScope, GlobalizationService, $window) {
		var vm = this;

		angular.extend(vm, {
			$onInit: init,
			enrollment: {}
		});

		 function goToVerizon() {
            var event;
			var redirectUrl = vm.enrollment ? vm.enrollment.RedirectUrl : null;
            switch(vm.enrollment.Status.Code) {
                case Constants.Status.QUALIFIED:
                    event = "QUALIFIED_REDIRECT_TO_VERIZON";
                    break;
                case Constants.Status.PENDING:
                    event= "PENDING_REDIRECT_TO_VERIZON";
                    break;
                case Constants.Status.REJECTED:
                case Constants.Status.UNQUALIFIED:
                    event = "UNQUALIFIED_REDIRECT_TO_VERIZON";
                    break;
            }

            if(event) {
                RestService.trackApplicationEvent(
                    event,
					redirectUrl
                );
            }

			$window.location.href = redirectUrl;
		}

		function init() {
			var config = StorageService.get(Constants.SK.Configuration);
            vm.enrollment = StorageService.get(Constants.SK.Application);
			vm.enrollmentNumber = vm.enrollment && vm.enrollment.EnrollmentNumber;	
			$rootScope.$broadcast('show-air-message', {
                    message: GlobalizationService.get('AIR_MESSAGE_COUNTDOWN_TEXT'),
                    showButton: false,
                    showCounter: true,
                    counterSeconds: config && config.redirectTimeoutInSeconds,
                    callback: function() {
						goToVerizon();
                    }
                });
		
        
		}
	}
})();